exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:767px){#tab-selector-teams{left:50%;right:0;width:50%}#tab-selector-teams .tab-select-icon{right:12px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=2!./assets/component/about/teams.vue
// module id = 283
// module chunks = 0